var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
export var applyHyphens = function (_a) {
    var breakWord = _a.breakWord;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n\n    ", "\n\n    overflow-wrap: var(--plasma-typo-overflow-wrap);\n    hyphens: var(--plasma-typo-hyphens);\n"], ["\n    ",
        "\n\n    ",
        "\n\n    overflow-wrap: var(--plasma-typo-overflow-wrap);\n    hyphens: var(--plasma-typo-hyphens);\n"])), breakWord === true &&
        "\n        --plasma-typo-overflow-wrap: break-word;\n        --plasma-typo-hyphens: auto;\n    ", breakWord === false &&
        "\n        --plasma-typo-overflow-wrap: normal;\n        --plasma-typo-hyphens: manual;\n    ");
};
var templateObject_1;
//# sourceMappingURL=applyHyphens.js.map